import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { en } from './locales/en';
import { am } from './locales/am';

Vue.use(VueI18n);

const words = {
    'en': en,
    'አማ': am,
    'ኦሮ': {
        slogan: 'baagga nagaa™',
        signup: 'SignUp',
        login: 'sennaa'
    },
    'ትግ': {
        slogan: 'ሰናይ ቀን™',
        signup: 'ይመዝገቡ',
        login: 'ይግቡ'
    }
};

export const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'am',
    messages: words,
});